import { Platform } from 'react-native';

export default {
  // apiBaseUrl: 'https://staging-chloe-api.peoplescience.health/api/',
  // socketUrl: 'https://staging-chloe-api.peoplescience.health/',
  // apiBaseUrl: 'https://chloe-api.peoplescience.health/api/',
  // socketUrl: 'https://chloe-api.peoplescience.health/',
  // apiBaseUrl: 'http://192.168.86.37:3000/api/',
  // socketUrl: 'http://192.168.86.37:3000/',
  apiBaseUrl:
    Platform.OS === 'android'
      ? 'http://10.0.2.2:3000/api/'
      : 'http://localhost:3000/api/',
  socketUrl:
    Platform.OS === 'android'
      ? 'http://10.0.2.2:3000/'
      : 'http://localhost:3000/',
  webUrl: 'http://localhost:3002',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: false,
  referralUrl: 'http://localhost:3002/referrals/',
  fitbitWebClientId: '238R5R',
  fitbitAppClientId: '238JF6',
  oAuthRedirectWebUri: 'https://localhost:19006/*',
  oAuthRedirectAppUri:
    'health.peoplescience.chloe2.development://MyStudiesScreen',
  ouraAppClientId: '4K2SDUYK5FZY2ZXS',
  googleFitScopes: [
    'https://www.googleapis.com/auth/fitness.sleep.read',
    'https://www.googleapis.com/auth/fitness.activity.read',
    'https://www.googleapis.com/auth/fitness.body.read',
    'https://www.googleapis.com/auth/fitness.nutrition.read',
    'https://www.googleapis.com/auth/fitness.blood_pressure.read',
    'https://www.googleapis.com/auth/fitness.blood_glucose.read',
    'https://www.googleapis.com/auth/fitness.oxygen_saturation.read',
    'https://www.googleapis.com/auth/fitness.body_temperature.read',
    'https://www.googleapis.com/auth/fitness.heart_rate.read'
  ],
  recaptchaSiteKey: '6LciVLYoAAAAAOpCrfDoYbh8dXyxN4ycIW30WDoZ',
  googleTagManagerId: 'GTM-TP4P4FQ',
  appcuesAppId: 'e5da3361-134f-4b8d-8d87-f1733c55ded4',
  appcuesAccountId: '209423'
};
